// Word-overlap heuristic for flagging churches with a suspiciously similar name.
// Shared by the admin Review tab (scraped-batch "possible duplicate" flag) and the
// live-table "find duplicates" tool (issue #81), so both surfaces agree on what
// counts as a name match instead of drifting apart over time.

const COMMON_CHURCH_NAME_WORDS = new Set([
  'church', 'fellowship', 'community', 'christian', 'baptist', 'methodist',
  'adventist', 'sda', 'assembly', 'chapel', 'ministry', 'ministries', 'of',
  'the', 'and', 'at', 'first', 'new', 'grace', 'life', 'living', 'faith',
])

export function normalizeChurchNameWords(name: string): string[] {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, '')
    .split(/\s+/)
    .filter((w) => w.length > 2 && !COMMON_CHURCH_NAME_WORDS.has(w))
}

/** True if two church names share enough distinctive words to flag as a likely match. */
export function churchNamesLikelyMatch(nameA: string, nameB: string): boolean {
  const wordsA = normalizeChurchNameWords(nameA)
  const wordsB = new Set(normalizeChurchNameWords(nameB))
  const overlap = wordsA.filter((w) => wordsB.has(w))
  return overlap.length >= 2 || (wordsA.length === 1 && wordsB.has(wordsA[0]))
}
